<template>
  <v-footer color="transparent" class="py-0">
      <v-card flat class="px-2" width="100%">
        <v-divider></v-divider>
        <v-card-actions class="px-0 mx-0">
            
            <!-- <span class="pa-2">
                <p class="mb-0"><strong>Ajuda</strong></p>
                <a v-for="item in itemsFooter" :key="item.name" name="item.name" link @click="$router.push(item.path).catch(()=>{})">
                    {{item.text1}}
                </a>
            </span> -->
            <!-- <span class="pa-2">
                <p class="mb-0"><strong>Legal</strong></p>
                <a v-for="item in itemsFooter" :key="item.name" name="item.name" link @click="$router.push(item.path).catch(()=>{})">
                    {{item.text2}}
                </a>
            </span> -->
            <span class="py-2">
                <p class="font-weight-black mb-0">&copy; Bionexo, {{ new Date().getFullYear() }}</p>
            </span>
            <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-footer>
</template>

<script>
export default {
  data() {
    return {
      itemsFooter: this.$router.options.routes[3].children,
    };
  }
}
</script>

<style>

</style>